// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PFK38Xqe5rndC4gbFKKk {
  width: 100%;
  height: 50vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Loader css come from: https://loading.io/css/ */

.q8mczlCgTy7gLDwhCHZe {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.q8mczlCgTy7gLDwhCHZe div {
  position: absolute;
  width: 6px;
  height: 6px;
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]};
  border-radius: 50%;
  animation: q8mczlCgTy7gLDwhCHZe 1.2s linear infinite;
}
.q8mczlCgTy7gLDwhCHZe div:nth-child(1) {
  animation-delay: 0s;
  top: 37px;
  left: 66px;
}
.q8mczlCgTy7gLDwhCHZe div:nth-child(2) {
  animation-delay: -0.1s;
  top: 22px;
  left: 62px;
}
.q8mczlCgTy7gLDwhCHZe div:nth-child(3) {
  animation-delay: -0.2s;
  top: 11px;
  left: 52px;
}
.q8mczlCgTy7gLDwhCHZe div:nth-child(4) {
  animation-delay: -0.3s;
  top: 7px;
  left: 37px;
}
.q8mczlCgTy7gLDwhCHZe div:nth-child(5) {
  animation-delay: -0.4s;
  top: 11px;
  left: 22px;
}
.q8mczlCgTy7gLDwhCHZe div:nth-child(6) {
  animation-delay: -0.5s;
  top: 22px;
  left: 11px;
}
.q8mczlCgTy7gLDwhCHZe div:nth-child(7) {
  animation-delay: -0.6s;
  top: 37px;
  left: 7px;
}
.q8mczlCgTy7gLDwhCHZe div:nth-child(8) {
  animation-delay: -0.7s;
  top: 52px;
  left: 11px;
}
.q8mczlCgTy7gLDwhCHZe div:nth-child(9) {
  animation-delay: -0.8s;
  top: 62px;
  left: 22px;
}
.q8mczlCgTy7gLDwhCHZe div:nth-child(10) {
  animation-delay: -0.9s;
  top: 66px;
  left: 37px;
}
.q8mczlCgTy7gLDwhCHZe div:nth-child(11) {
  animation-delay: -1s;
  top: 62px;
  left: 52px;
}
.q8mczlCgTy7gLDwhCHZe div:nth-child(12) {
  animation-delay: -1.1s;
  top: 52px;
  left: 62px;
}

@keyframes q8mczlCgTy7gLDwhCHZe {
  0%, 20%, 80%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/library/Loading/Loading.module.css"],"names":[],"mappings":"AAGA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,kDAAkD;;AAElD;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,wDAAsB;EACtB,kBAAkB;EAClB,oDAAuC;AACzC;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF","sourcesContent":["@value colors: '../style/colors.css';\r\n@value color-gray from colors;\r\n\r\n.loadingContainer {\r\n  width: 100%;\r\n  height: 50vh;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n/* Loader css come from: https://loading.io/css/ */\r\n\r\n.loading {\r\n  display: inline-block;\r\n  position: relative;\r\n  width: 80px;\r\n  height: 80px;\r\n}\r\n.loading div {\r\n  position: absolute;\r\n  width: 6px;\r\n  height: 6px;\r\n  background: color-gray;\r\n  border-radius: 50%;\r\n  animation: loading 1.2s linear infinite;\r\n}\r\n.loading div:nth-child(1) {\r\n  animation-delay: 0s;\r\n  top: 37px;\r\n  left: 66px;\r\n}\r\n.loading div:nth-child(2) {\r\n  animation-delay: -0.1s;\r\n  top: 22px;\r\n  left: 62px;\r\n}\r\n.loading div:nth-child(3) {\r\n  animation-delay: -0.2s;\r\n  top: 11px;\r\n  left: 52px;\r\n}\r\n.loading div:nth-child(4) {\r\n  animation-delay: -0.3s;\r\n  top: 7px;\r\n  left: 37px;\r\n}\r\n.loading div:nth-child(5) {\r\n  animation-delay: -0.4s;\r\n  top: 11px;\r\n  left: 22px;\r\n}\r\n.loading div:nth-child(6) {\r\n  animation-delay: -0.5s;\r\n  top: 22px;\r\n  left: 11px;\r\n}\r\n.loading div:nth-child(7) {\r\n  animation-delay: -0.6s;\r\n  top: 37px;\r\n  left: 7px;\r\n}\r\n.loading div:nth-child(8) {\r\n  animation-delay: -0.7s;\r\n  top: 52px;\r\n  left: 11px;\r\n}\r\n.loading div:nth-child(9) {\r\n  animation-delay: -0.8s;\r\n  top: 62px;\r\n  left: 22px;\r\n}\r\n.loading div:nth-child(10) {\r\n  animation-delay: -0.9s;\r\n  top: 66px;\r\n  left: 37px;\r\n}\r\n.loading div:nth-child(11) {\r\n  animation-delay: -1s;\r\n  top: 62px;\r\n  left: 52px;\r\n}\r\n.loading div:nth-child(12) {\r\n  animation-delay: -1.1s;\r\n  top: 52px;\r\n  left: 62px;\r\n}\r\n\r\n@keyframes loading {\r\n  0%, 20%, 80%, 100% {\r\n    transform: scale(1);\r\n  }\r\n  50% {\r\n    transform: scale(1.5);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `'../style/colors.css'`,
	"color-gray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]}`,
	"loadingContainer": `PFK38Xqe5rndC4gbFKKk`,
	"loading": `q8mczlCgTy7gLDwhCHZe`
};
export default ___CSS_LOADER_EXPORT___;
